<template>
    <div class="form">
        <a-card size="small" :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
            <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout" :label-col="labelCol"
                :wrapper-col="wrapperCol">
                <a-form-model-item ref="platformcode" label="平台编码" prop="platformcode">
                    <platformSelecter v-show="is_new" :platformcode="record.platformcode"   @platformChange="handlePlatformChange"></platformSelecter>
                    <span v-show="!is_new"> {{ platformName }} </span>
                </a-form-model-item>

                <!-- 非必须参数 -->
                <a-form-model-item ref="catalogcode" label="所属目录" prop="catalogcode">
                    <catalog v-if="is_new" :platformcode="record.platformcode" :mmkey="record.catalogcode" @catalogcodechange="handleCatlogChange" ></catalog>
                    <span v-else>{{record.catalogcode}}</span>
                </a-form-model-item>

                <a-form-model-item ref="configcode" label="配置编码" prop="configcode">
                    <a-input v-if="is_vue_task" v-model="record.configcode" />
                    <span v-else>{{record.configcode}}</span>
                </a-form-model-item>

                <a-form-model-item ref="configname" label="配置名称" prop="configname">
                    <a-input v-if="is_vue_task" v-model="record.configname" />
                    <span v-else>{{record.configname}}</span>
                </a-form-model-item>

                <a-form-model-item ref="configvalue" label="配置值" prop="configvalue">
                    <JsonXmlEditor :title="'配置值：'"  v-model="record.configvalue"></JsonXmlEditor>
                </a-form-model-item>

               
                <a-form-model-item v-show="is_vue_task" :wrapper-col="{ span: 14, offset: 8 }">
                    <a-button type="primary" @click="handleOk" :loading="confirmLoading">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>

        </a-card>
    </div>

</template>
<script>
import catalog from '../com/catalog'
import platformSelecter from '../com/platformSelecter'
import JsonXmlEditor from '../../../components/JsonXmlEditor'

const m_title = {
    'addsimpconfig':'新增简单配置',
    'detailsimpconfig':'查看简单配置',
    'editsimpconfig':'编辑简单配置',
};
export default {
    data() {
        return {
            c_title:'',
            is_vue_task : true,
            is_new:false,
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            rules: {
                platformcode: [
                    { required: true, message: ' 请选择平台 ', trigger: 'blur' },
                ],
                configcode:[
                    { required: true, message: ' 请填写配置编码', trigger: 'blur' },
                ],
                configname:[
                    { required: true, message: '请填写配置名称', trigger: 'blur' },
                ],
                configvalue:[
                    { required: true, message: '请输入配置值', trigger: 'blur' },
                ],
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            record:{
                platformcode:'',
                platformname:'',//附加字段，子组件线上平台名称
                configcode:'',
                configname:'',
                catalogcode:'',//目录
                configvalue:'',
            },
            platformlist:[{text:'',value:''}]
        };
    },
    computed: {
        platformName(){
            let result = this.platformlist.find(item=>{return item.value == this.record.platformcode});
            if(result){
                return result.text
            }
            else{
                return ''
            }
        }
    },
    components:{
        platformSelecter,
        catalog,
        JsonXmlEditor
    },
    methods: {
        handleCatlogChange(v){
            this.record.catalogcode = v;
        },
        handlePlatformChange(obj){
            this.record.platformcode = obj.platformcode;
            this.record.platformname = obj.platformname;
            this.platformlist = obj.platformlist;
        },
        handleOk() {
            let that = this;
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    that.confirmLoading = true;
                    const { params } = that.$route;
                    if(params.action == 'editsimpconfig'){
                        that.$store
                            .dispatch({
                                type: "cloudconfig/simpedit",
                                params: {
                                    ...that.record,
                                    operateuser:this.G.getCurrentUser().username,
                                    urlparams: false,
                                }
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                    that.confirmLoading = false;
                                }
                            });
                    }
                    else if(params.action == 'addsimpconfig'){
                        that.record.id = '';
                        //新增
                        that.$store
                            .dispatch({
                                type: "cloudconfig/simpadd",
                                params: {
                                    ...that.record,
                                    createuser:this.G.getCurrentUser().username,
                                    urlparams: false,
                                }
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                }
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },

        getDetail(query){
            let that = this;
            that.$store.dispatch({
                type: "cloudconfig/simpdetail",
                params: {
                    platformcode:query.platformcode,
                    configcode:query.configcode
                },
                showMsg: false
            }).then((res) => {
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.record = {
                        ...result
                    }
                    that.$refs.rangeRuleSelecter.init(result.rangerule,result.rangerulename)
                }
            });
        }
    },

    mounted(){
        const { query, params } = this.$route;
        this.c_title = m_title[params.action];
        this.is_new = params.action == "addsimpconfig";
        if (!this.is_new) {
            this.getDetail(query)
        }
        else{
            this.resetForm();
        }
        this.record.platformcode = query.platformcode
        this.is_vue_task = params.action != 'detailsimpconfig'

    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
